import { GetRacArisRulesResponse } from "@/app/api/rac-aris-rules/route";
import { getRacArisRulesRequestSchema } from "@/lib/schemas/rac-aris-rules";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";

const RAC_ARIS_RULES_ENDPOINT = "/api/rac-aris-rules";

export const invalidateRacArisRulesQuery = createInvalidateQuery(
  RAC_ARIS_RULES_ENDPOINT,
);

export const useRacArisRulesQuery = createQueryHook<GetRacArisRulesResponse>(
  RAC_ARIS_RULES_ENDPOINT,
  getRacArisRulesRequestSchema,
);
